import { TFunction } from "i18next";
import * as Yup from "yup";

export const getTopicFormSchema = (t: TFunction) =>
    Yup.object().shape({
        code: Yup.string()
            .trim()
            .required(t("common:form.requiredFieldForm")),
        description: Yup.object()
            .shape({
                catalan: Yup.string()
                    .trim()
                    .required(t("common:form.requiredFieldForm")),
                spanish: Yup.string()
                    .trim()
                    .required(t("common:form.requiredFieldForm")),
                english: Yup.string()
                    .trim()
                    .required(t("common:form.requiredFieldForm")),
            })
            .required(t("common:form.requiredFieldForm")),
    });

